import { DotLegalEmptyState } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "../../../localization/useTranslation";
import FailedSvg from "./documentPreviewFailed.svg?react";
import { Box } from "@mui/material";

function DocumentPreviewFailed() {
    const { translateString } = useTranslation();

    return (
        <DotLegalEmptyState
            icon={<FailedSvg />}
            text={
                <Box
                    sx={(theme) => ({
                        color: theme.palette.primary.dark,
                        fontSize: theme.typography.pxToRem(14),
                        marginBottom: theme.spacing(1),
                    })}
                >
                    {translateString("failedToLoadDocument")}
                </Box>
            }
        />
    );
}

export default DocumentPreviewFailed;
